import type { Messages } from './de';
import common from './en/common';
import shell from './en/shell';
import heute from './en/heute';
import mehr from './en/mehr';
import settings from './en/settings';
import activities from './en/activities';
import activity from './en/activity';
import maps from './en/maps';
import analysis from './en/analysis';
import health from './en/health';
import goals from './en/goals';
import planning from './en/planning';
import wrapped from './en/wrapped';
import weather from './en/weather';
import races from './en/races';
import season from './en/season';
import gear from './en/gear';

/** Englisch, Namensraum für Namensraum gegen `Messages` geprüft. */
export const en: Messages = { common, shell, heute, mehr, settings, activities, activity, maps, analysis, health, goals, planning, wrapped, weather, races, season, gear };
